export default __webpack_public_path__ + "static/media/banner_visa.fa7ebd56.png";